import { PropertyType } from '../shared/rte-form/schema/property-type.enum';

export function getPropertyTypeBySystemType(systemType: string): PropertyType {
  let type: PropertyType;

  switch (systemType) {
    case 'DECIMAL':
    case 'INTEGER':
    case 'LONG':
      type = PropertyType.Number;
      break;
    case 'DATE':
    case 'DATETIME':
    case 'TIMESTUMP':
      type = PropertyType.Date;
      break;
    case 'STRING':
    default:
      type = PropertyType.Text;
      break;
  }

  return type;
}
